import { ADMISSION_STATUSES } from '../constants/admissionStatus';

// Plain labels for the D2 audit actions (webapp/backend/src/services/audit_actions.py).
// webapp/backend/tests/unit/test_audit_action_labels.py fails when an action has no label here.
export const AUDIT_ACTION_LABELS = {
    'case.create': 'Created a case',
    'case.upload': 'Uploaded a file',
    'case.remove_file': 'Removed a file',
    'case.process': 'Processed a case',
    'case.retry': 'Retried processing',
    'case.generate': 'Generated documents',
    'case.suggest_codes': 'Suggested diagnosis codes',
    'case.status_change': 'Changed admission status',
    'case.reassign': 'Reassigned a case',
    'case.archive': 'Archived a case',
    'case.delete': 'Deleted a case',
    'case.export': 'Exported a case',
    'user.invite': 'Created an invite',
    'user.register': 'Registered',
    'user.disable': 'Changed sign-in access',
    'user.delete': 'Deleted a user',
    'user.offboard': 'Offboarded a member',
    'user.mfa_reset': 'Reset two-step verification',
    'member.role_change': 'Changed a role',
    'member.remove': 'Removed a member',
    'facility.create': 'Created the facility',
    'facility.billing_change': 'Changed billing',
    'facility.purge': 'Purged the facility',
    'admin.view_user_cases': 'CensusZen staff viewed a user',
    'config.update': 'Changed extraction settings',
};

export function actionLabel(action) {
    return AUDIT_ACTION_LABELS[action] || action;
}

export function shortId(id) {
    return id ? String(id).slice(0, 8) : '';
}

export function actorLabel(uid, names) {
    if (uid === 'system:scheduler') return 'System (nightly job)';
    if (typeof uid === 'string' && uid.startsWith('system:')) return 'System';
    return names[uid] || shortId(uid);
}

// Audit rows record a status by enum name (IN_PROGRESS), not by label (In progress).
// Build the lookup from the one list of statuses the app already uses.
const STATUS_NAME_LABELS = Object.fromEntries(
    ADMISSION_STATUSES.map((label) => [label.toUpperCase().replace(/ /g, '_'), label])
);

export function statusLabel(name) {
    return STATUS_NAME_LABELS[name] || name;
}
